import React , {useState, useRef } from 'react';
import { Button } from 'antd';
import QRCode from '@/components/QRCode';
import './index.less';
import {MOCKDATA} from '@/utils/data';

const Index = (props) => {
    const { t } = props;
    const [data,setData] = useState(MOCKDATA.data||[]); 
    const timeIdRef = useRef(null);
    const [activeObj, setActiveObj] = useState({});

    const downClick = (item) => {
        setActiveObj({
            ...item,
           loading: true
        });
        timeIdRef.current && clearTimeout(timeIdRef.current);
        timeIdRef.current = setTimeout(() => {
            setActiveObj({
            ...item,
           loading: false
        });
        }, 1000);
        window.open(item.url);
    }
    return(
        <div className="pc_page">
            <div className="header">
                 <div className="title">{t('title')}</div>
                 <div className="sub_title">{t('titleSub')}</div>
            </div>
            <div className="main">
                <div className="card_wrap">
                    {
                        data.map((item, index) => {
                            return(
                                <div className="card" key={index}>
                                    <div className={`icon icon_${item.os}`}></div>
                                    <div className="title">{item.name}</div>
                                    <div className="btn_box">
                                        <Button
                                         className="btn" 
                                         type="primary" 
                                         loading={activeObj.loading&&activeObj.id===item.id}
                                         onClick={() => downClick(item)}
                                        >{t('download')}</Button>
                                    </div>
                                    <div className={`tip`}>{item.tip}</div>
                                    {
                                        (item.os === 'iOS'||item.os === 'Android') && (
                                            <div className="card_qrbox">
                                                <QRCode qaUrl={window.location.href} className="card_qr" ></QRCode>
                                                <div className="btn_box">
                                                        <Button
                                                            className="btn btn_qrcode" 
                                                            type="primary" 
                                                            loading={activeObj.loading&&activeObj.id===item.id}
                                                            onClick={() => downClick(item)}
                                                            >{t('download')}</Button>
                                                    </div>
                                            </div>
                                        )
                                    }
                                    
                                </div> 
                            ) 
                        })
                    }
                </div>
            </div>
        </div>
    )
}
export default Index;